import { Flex, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation('common');

  return (
    <Flex direction='column' height='140px' justifyContent='center' alignItems='center' px={2}>
      <Text textAlign='center'>
        {t('footer')}{' '}
        <Link
          href='https://www.thesongslaboratory.com/en/home'
          isExternal
          textDecoration='underline'
        >
          TSL Karaoke
        </Link>
      </Text>
    </Flex>
  );
}

export default Footer;
